import { render, staticRenderFns } from "./PaymentThankYou.vue?vue&type=template&id=44f0301a&scoped=true&"
import script from "./PaymentThankYou.vue?vue&type=script&lang=js&"
export * from "./PaymentThankYou.vue?vue&type=script&lang=js&"
import style0 from "./PaymentThankYou.vue?vue&type=style&index=0&id=44f0301a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f0301a",
  null
  
)

export default component.exports